import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import ConsumerCheckoutLoginCreateAccountModalContent from '../ConsumerCheckout/Components/ConsumerCheckoutLoginCreateAccountModalContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '3rem 0 0rem',
        border: '0.2rem solid #7048b3',
        borderRadius: '1.5rem',
        [theme.breakpoints.up('md')]: {
            padding: '3rem 3rem 0rem',
        },
    },
    closeButton: {
        color: theme.palette.grey[500],
        width: 'min-content',
        position: 'absolute',
        right: 0,
        top: 0,
    },
}))

const ConsumerCheckoutLoginCreateAccountModal = (props) => {
    const { modalIsOpen, closeModal } = props
    const classes = useStyles()

    return (
        <Dialog
            open={modalIsOpen}
            classes={{
                paper: classes.container,
            }}
            onBackdropClick={closeModal}
        >
            <IconButton
                aria-label="close"
                onClick={closeModal}
                className={classes.closeButton}
            >
                <CloseIcon style={{ fontSize: '2.25rem' }} />
            </IconButton>
            <DialogContent>
                <ConsumerCheckoutLoginCreateAccountModalContent {...props} />
            </DialogContent>
        </Dialog>
    )
}

export default ConsumerCheckoutLoginCreateAccountModal
